import React from "react";
import { useField } from "formik";
import FieldError from "./FieldError";

const Select = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      {label && <label htmlFor={props.id || props.name}>{label}</label>}
      <select {...field} {...props} />

      {meta.touched && meta.error && <FieldError error={meta.error} />}
    </>
  );
};
export default Select;
